module.exports = __webpack_public_path__ + "img/za.0f05edd2.svg";